import React, { Component } from "react";
import { Icon } from "semantic-ui-react";
import firebase from "../../firebase";

class LikeButton extends Component {
  constructor(props) {
    super(props);
    //console.log(this.props.message);
    //console.log(this.props.user.uid);

    this.state = {
      likesRef: firebase.database().ref("likes"),
      likes: "",
      isChecked: false,
      isMounted: false
    };
  }

  componentDidMount() {
    this.state.isMounted = true;
    this.isChecked(this.props.message);
    this.getLikes(this.props.message);
  }
  componentWillUnmount() {
    this.state.isMounted = false;
  }

  componentWillUnmount() {
    this.state.isMounted = false;
  }

  getLikes(message) {
    message.id &&
      this.state.likesRef.child(message.id).on(
        "value",
        snapshot =>
          this.state.isMounted &&
          this.setState({
            likes: snapshot.val() && Object.keys(snapshot.val()).length
          })
      );
  }

  isChecked(message) {
    message.id &&
      this.state.likesRef
        .child(message.id)
        .child(this.props.user.uid)
        .on("value", snapshot => {
          this.state.isMounted && this.setState({ isChecked: snapshot.val() });
          return snapshot.val();
        });
  }

  updateLikes(message) {
    let user = this.props.user.uid;
    let update = {};
    update[user] = true;
    message.id && this.state.likesRef.child(message.id).update(update);
  }

  deleteLikes(message) {
    message.id &&
      this.state.likesRef
        .child(this.props.message.id)
        .child(this.props.user.uid)
        .remove();
  }

  onClick() {
    !this.state.isChecked && this.updateLikes(this.props.message);
    this.state.isChecked && this.deleteLikes(this.props.message);
    this.isChecked(this.props.message);
  }

  render() {
    return (
      <div>
        <Icon
          name={this.state.isChecked ? "heart" : "heart outline"}
          style={{ color: this.state.isChecked ? "red" : "" }}
          onClick={() => this.onClick()}
        />
        {this.state.likes}
      </div>
    );
  }
}

export default LikeButton;



// WEBPACK FOOTER //
// ./src/components/Messages/LikeButton.js